import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const GlobalQuestionsListMacroHandler: LoadableType<{
	macroDefaultProps: ExtensionHandlerProps;
	macroParams: any;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalQuestionsListMacroHandler" */ '../src/GlobalQuestionsListMacroHandler.tsx'
			)
		).GlobalQuestionsListMacroHandler,
});
